import { render } from "./AppLayout.vue?vue&type=template&id=5b01577c"
import script from "./AppLayout.vue?vue&type=script&lang=js"
export * from "./AppLayout.vue?vue&type=script&lang=js"

import exportComponent from "/data/tfs-agent-build/agent/_work/7/s/30-Frontend/Frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/AppLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b01577c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b01577c', __exports__)) {
    api.reload('5b01577c', __exports__)
  }
  
  module.hot.accept("./AppLayout.vue?vue&type=template&id=5b01577c", () => {
    api.rerender('5b01577c', render)
  })

}


export default __exports__